import React from 'react';
import {
  Container,
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';

import 'firebaseui/dist/firebaseui.css';
import '../../css/Login.css';
import AppComponent from './AppComponent';

class Login extends AppComponent {
  componentDidMount() {
    if (!this.app.user) {
      this.app.firebaseService.startFirebaseUI('#firebaseui-auth');
    }
  }

  componentWillUnmount() {
    this.app.firebaseService.resetFirebaseUI();
  }

  renderFirebaseUI = () => (
    <Container id="main-container">
      <Card className="hotsheet-Login text-center">
        <CardHeader>
          <strong>Login / Register</strong>
        </CardHeader>
        <CardBody>
          <div id="firebaseui-auth" />
        </CardBody>
      </Card>
    </Container>
  );

  render() {
    const { user } = this.app;
    const redirectPath = (this.props.location.state && this.props.location.state.from) || '/alerts';
    return (
      <div>
        {
          user
            ? <Redirect to={redirectPath} />
            : this.renderFirebaseUI()
        }
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/core/Login.js